import React , { useState , useEffect } from 'react';
import moins  from '../img/moins.png';
import plus from  '../img/plus.png';

function QuestionEnfants (props) { 
	const [nbEnfants ,setNbEnfant] = useState(0);
	const [hasChild , setHasChild] = useState(false);

	const inputElement = document.getElementById("enfants");
	const substractNb = (e)=>{
		const newValue = nbEnfants > 0 ? nbEnfants-1 : 0  ;
		inputElement.value = newValue;
		setNbEnfant(newValue);
	}

	const incrementNb = (e)=>{
		const newValue = nbEnfants+1;
		inputElement.value = newValue;
		setNbEnfant(newValue);
	}

	const updateNbEnfants  = (e)=>{
		let newValue = parseInt(e.target.value);
		newValue = isNaN (newValue) || newValue<0 ? 0 : newValue;

		setNbEnfant(newValue);
	}

	const updateHasChild = (e)=>{
		const newValue = JSON.parse(e.target.value);
		setHasChild( newValue );
	}

	useEffect( ()=>{
		props.handleData(
			{
				"hasChild" : hasChild,
				"number" : nbEnfants
			}
		)
	} , [hasChild,nbEnfants]);
	return <>
	  <div className="pn_accordion">
	    <div className="acc_head qrow" id="avec_enfant">
	      <input type="radio" name="enfant" id="avec_enfant" value={true} onChange={updateHasChild} />
	      <span className="checkmark"></span>
	      <label>Oui</label>
	    </div>
	    { (hasChild) ? 
		    <div className="number" >
		      Nb d'enfants à charge
		      <div className="pn_signes_container">
		        <span
		        	id="minus"
		        	className="pn_signes"
		        	onClick={substractNb}
		        >
		          <img src={moins} />
		        </span>
		        <input type="text"
		        	placeholder="0"
		        	id="enfants"
		        	onChange={updateNbEnfants}
		        />
		        <span
		        	id="plus"
		        	className="pn_signes"
		        	onClick={incrementNb}
		        >
		          <img src={plus} />
		        </span>
		      </div>
		    </div> : '' }
	  </div>


	  <div className="pn_accordion">
	    <div className="acc_head qrow" id="sans_enfant">
	      <input type="radio"  name= "enfant" id="sans_enfant" value={false} onChange={updateHasChild}  />
	      <span className="checkmark"></span>
	      <label>Non</label>
	    </div>
	  </div>
	</>;
}

export  {QuestionEnfants};